/**
 * Phase 10 — a shared minimal splash for App.tsx's `"boot"` and
 * `"sync"` screens (Master Spec §42's BOOT and SYNC steps). Deliberately
 * just a spinner and one line of text: neither step has meaningful
 * progress to report yet (a byte-level upload/download progress bar
 * would be premature polish for what is currently a handful of small
 * JSON requests — revisit if a later phase's sync payloads grow large
 * enough to need one).
 */
export interface LoadingScreenProps {
  message: string;
}

export function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-slate-900 text-slate-100">
      <div className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-slate-600 border-t-emerald-500" />
      <p className="text-sm text-slate-400">{message}</p>
    </div>
  );
}
